import styled,{css} from 'styled-components'
import {Divider} from 'antd'
import Flex from './Flex';


export const SkillsHeading = styled.div`
  font-size: 16px;
  font-weight: 700;
  lineHeight:21px;
  padding-bottom:20px;
`;

export const SkillsSubHeading = styled.div`
  font-size: 16px;
  font-weight: 700;
  lineHeight:21px;
  padding-bottom:10px;
`;


export const SkillSetHeading = styled.div`
  font-size: 16px;
  font-weight: 600;
  lineHeight:21px;
  padding-bottom:10px;

`;


export const ExtraPaddingNew =styled.div`
padding-bottom:15px;
`;

export const ExtraPadding =styled.div`
padding-bottom:5px;
`;

export const HeaderFixed = styled.div`
padding-left: 25px;
padding-right:20px;
padding-top:10px ;
position: fixed;
top: 0;
height: 75px;
width:40%;
background-color: #fff;
`;


export const HeaderFixedNew = styled.div`
padding-left: 25px;
padding-right:20px;
padding-top:10px ;
position: fixed;
top: 0;
height: 210px;
background-color: #fff;
`;

export const FooterFixed = styled.div`
padding-bottom: 18px;
padding-right: 15px;
position: fixed;
bottom: 0;
height: 60px;
width:40%;
background-color: #fff;
`;

export const ContentStyle = styled.div`
margin-top: 10px; /* Height of fixed header */
margin-bottom: 10px; /* Height of fixed footer */
overflow-y: auto;
max-height: calc(100vh - 135px); /* Height of viewport minus header and footer heights */
&::-webkit-scrollbar {
  width: 10px;
  display: '';
}

&::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color:#cacaca;
  display: '';
}
&:hover {
  ::-webkit-scrollbar-thumb {
    display: block;
  }

`;

export const ContentStyleNew = styled.div`
margin-top: 10px; /* Height of fixed header */
margin-bottom: 10px; /* Height of fixed footer */
overflow-y: auto;
// max-height: calc(100vh - 270px); /* Height of viewport minus header and footer heights */
&::-webkit-scrollbar {
  width: 10px;
  display: '';
}

&::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background-color:#cacaca;
  display: '';
}
&:hover {
  ::-webkit-scrollbar-thumb {
    display: block;
  }
`;

export const contentPadding=styled.div`
padding-left:15px;
padding-right:35px;
padding-top:15px;

`

export const ExtraPaddingLast =styled.div`
padding-bottom:40px;
`;

export const ExtraPaddingSkills =styled.div`
padding-bottom:15px;
`;

export const SkillsHeadingPadding =styled.div`
padding-bottom:10px;
`;


export const ExtraPaddingLeftSkill =styled.div`
padding-left:22px;
`;

export const ExtraPaddingLeftSkill1 =styled.div`
padding-left:44px;
`;


export const ExtraPaddingTitle =styled.div`
padding-left:90px;
`;

export const ExtraPaddingLeft =styled.div`
padding-left:120px;
`; 

export const ExistingSkills = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 18px;
  color: #3249D7;
  border: 1px solid #D6DBF7;
  border-radius: 12px;
  padding: 10px 22px;
  margin: 5px;
  cursor: pointer;
  min-width: fit-content; /* Use fit-content to adjust width based on content size */
`;


export const LocationDescription=styled.div`
font-size: 14px;
font-weight: 600;
lineHeight:22px;
color:#4D566E;
`;

export const ExperienceDescription=styled.div`
font-size: 14px;
font-weight: 600;
lineHeight:22px;
padding-bottom:15px;
color:#4D566E;
`;


export const ExperienceNote=styled.div`
font-size: 14px;
font-weight: 600;
lineHeight:22px;
padding-bottom:15px;
padding-top:10px;
color:#5db594;
`;




export const LocationNote=styled.div`
font-size: 14px;
font-weight: 600;
lineHeight:18px;
padding-top:15px;
color:#999FAC;
margin-bottom:20px;
`;


export const SelectedExistingSkills = styled(ExistingSkills)`
  background-color: #3249D7;
  color: white;
  cursor:pointer;

`;


export const ReleventExpHeading = styled.div`
  font-size: 16px;
  font-weight: 700;
  lineHeight:21px;
  padding-bottom:20px;
  padding-top:10px;
  padding-left:10px;
`;

export const VerticalDivider = styled(Divider)`

height: auto;
width:1px;
background:#E6E7EA;
margin:0 !important;
`;


export const ScrollBar = styled.div`
  height: ${props => (props?.height ? props?.height : '100vh')};
  overflow: auto;
  overflow-y: auto;
  &::-webkit-scrollbar {
    width: 10px;
    display: '';
  }

  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color:#cacaca;
    display: '';
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      display: block;
    }
  
`

export const CarouselContainer = styled.div`
    display: flex;
    flex-direction: column;
  `;
  
export const SilderDiv =styled.div`
    width: '85%';
    margin-left:'20px';
` 
export const HorizontalDividerSkill = styled.div`
  width:auto;
  background:#D6DBF7;
  height: 1.5px;
  
`;

export const HorizontalDividerSkillExt = styled.div`
  width:auto;
  background:#D6DBF7;
  height: 1.5px;
  margin-bottom:20px;
`;


export const HorizontalDivider = styled.div`
  width:auto;
  background:#E6E7EA;
  height: 1px;

`;

export const HorizontalDividerTitle = styled.div`
  width:auto;
  background:#E6E7EA;
  height: 1px;
  dispaly:inline-block;
  padding:0px !important;
  padding:0px !important;
`;

export const SpinWrapper = styled(Flex)`
  padding-top: 25px;
`

export const ExampleElement = styled.div`
  display: inline-block; /* Display as inline-block to adjust width based on content */
  //min-width: 93px; /* Set a minimum width */
  height: 32px;
  padding: 7px;
  border-radius: 12px;
  border: 1.5px solid #D6DBF7; /* Border color */
  background: #FFFFFF; /* Background color */
  text-align: center; /* Center the text within the element */
  white-space: nowrap; /* Ensure text appears in a single line */
  overflow: hidden; /* Hide any overflow content */
  text-overflow: ellipsis; /* Show an ellipsis (...) if text overflows */
`;

export const FlexWrap = styled(Flex)`
  position: relative;
  gap: ${props => (props.gap ? props.gap : '0px')};
  padding: ${props => (props.padding ? props.padding : '0px')};
  background-color: ${props => (props.bgColor ? props.bgColor : 'transparent')};
`

export const ButtonLocal = styled.button`
  width: auto;
  max-width: 240px;
  background: #FBFAFF;
  border: 1px solid #E3DEFF;
  border-radius: 10px;
  cursor: pointer;
  padding-bottom: 5px;
  padding-top: 5px;
  padding-left: 25px;
  padding-right: 25px;

  /* Apply disabled styles when the 'disabled' prop is set to true */
  ${(props) => props.disabled && css`
    cursor: not-allowed;
    opacity: 0.5;
    pointer-events: none;
  `}
`;


export const UpdateContent =styled.div`
font-size: 16px;
font-weight: 400;
lineHeight:20px;
color:#4D566E;
`

export const ScrollContainer = styled.div`
  max-height: 400px;
  overflow-y: auto;
  overflow-x: hidden;
  @media (max-width: 768px) {
    max-height: 200px;
  }
`;

export const CarouselWrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: nowrap; /* Forces the items to stay in a single line */
  overflow-x: auto;
  scroll-behavior: smooth;
  ::-webkit-scrollbar {
    display: ''; /* Hide scrollbars on WebKit browsers */
  }
  &::-webkit-scrollbar {
    height: 8px;
  }
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color:#cacaca;
    display: '';
  }
  &:hover {
    ::-webkit-scrollbar-thumb {
      display: block;
    }
  }
`


export const ArrowContainer = styled.div`
  display: flex;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  color: #555;
  margin: 5px;
  font-size: 20px;
  transition: background-color 0.3s;
  &:hover {
  }
`;

export const LeftArrow = styled(ArrowContainer)`
  position: sticky;
   left: 0;
  padding-top: 44px;
  padding-right:0px;
  transform: translateY(-50%);
  z-index: 999; /* Adjust the z-index to ensure arrows are on top */
`;

export const RightArrow = styled(ArrowContainer)`
  position: sticky;
  right: 0;
  padding-top: 44px;
  transform: translateY(-50%);
  z-index: 999; /* Adjust the z-index to ensure arrows are on top */
`;


export const SkillHeading = styled.div`
  padding-left: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${props => props.color}; // Use the color prop here

`

export const CountHeading = styled.div`
  padding-left:3px;
  font-weight: 500;
  font-size: 14px;
  line-height: 21px;
  color:'#343E59'; 
`

export const AddSkillHeading = styled.div`
  padding-left: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  //cursor:pointer;
  cursor: ${props => (props.disable ? 'not-allowed' : 'pointer')}; /* Change cursor based on isAdding prop */
  margin-left:auto;
  color: ${props => (props.isAdded ? '#3249D7' : '#999FAC')};
  &:hover{
    color: ${props => (props.disable ? '#999FAC' : '#3249D7')};
  }

`;




export const AddedSkillHeading = styled.div`
  padding-left: 10px;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  margin-left:auto;
  font-style:Italic;
  color: ${props => (props.isAdded ? '#3249D7' : '#26D894')};

`;

export const TopHeading = styled(Flex)`
  margin-bottom: 5px;
  padding-top:5px;
  background-color: ${props => (props.isAdded ? '#F6F6F6' : 'none')};
  &:hover {
  background-color: ${props => (props.disable ? 'none' : '#F6F6F6')};
  }
`;